<template>
    <b-card no-body>
        <div>
            <b-modal id="cell-balance-detail-modal" title="Stok Detayı" size="lg" scrollable hide-footer v-on:hidden="clearForm">
                <cell-balance-detail-view :item="selectedItem" />
            </b-modal>

            <v-table ref="table" :items-provider="provider" :fields="fields" :buttons="buttons" pagination="client" search />
        </div>
    </b-card>
</template>

<script>
import { WarehouseApi } from "@/api/warehouse/index.js";
import { BCard, BModal } from "bootstrap-vue";
import CellBalanceDetailView from "./components/CellBalanceDetailView.vue";

export default {
    name: "CellBalanceView",
    components: {
        BCard,
        BModal,
        CellBalanceDetailView,
    },
    data() {
        return {
            fields: [
                { key: "CellLocation.CellName", name: "Hücre Adı", thClass: "w-25" },
                { key: "StockCode", name: "Stok Kodu", thClass: "w-25" },
                { key: "Balance", name: "Stok Miktarı", thClass: "w-25" },
                { key: "CellLocation.WarehouseCode", name: "Depo Kodu", thClass: "w-25" },
            ],
            buttons: [{ key: "detail", icon: "EyeIcon", variant: "info", text: "Detay", action: this.showDetailModal }],
            selectedItem: {},
        };
    },
    methods: {
        async provider(ctx) {
            this.$refs.table.setLoading(true);
            try {
                const response = await WarehouseApi.getListCellBalance({ StockCode: ctx.QueryParam || "" });
                const items = response.data.Data || [];
                this.$refs.table.setItems(items);
                this.$refs.table.setTotal(items.length);
            } catch (error) {
                console.error("Hücre bakiye listesi alınırken hata oluştu:", error);
                this.$result(null, error);
                this.$refs.table.setItems([]);
                this.$refs.table.setTotal(0);
            } finally {
                this.$refs.table.setLoading(false);
            }
        },
        showDetailModal(item) {
            this.selectedItem = { ...item };
            this.$bvModal.show("cell-balance-detail-modal");
        },
        clearForm() {
            this.selectedItem = {};
        },
    },
};
</script>
